import {Component, Input, OnInit} from '@angular/core';
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-banners',
    templateUrl: './banners.component.html',
    styleUrls: ['./banners.component.scss'],
})
export class BannersComponent implements OnInit {

    @Input() banners: any[] | undefined = undefined;

    constructor(public myGcService: MyGreenCountry,) {
    }

    ngOnInit() {
    }

    mainBannerClick(url: string) {

        //@TODO what is the Additionals
        if (url == '') {

            // this.goToAdditionals();

        } else {

            this.myGcService.openUrl(url);

        }

    }
}
